function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34" {...props}><g fill="none" fillRule="evenodd" transform="translate(1 1)"><circle cx="16" cy="16" r="16" fill="#F6F7FB" stroke="#D7DBE9" /><g fill="#6A6D7B" fillRule="nonzero"><path d="M22.125 15.125a.875.875 0 1 1 0 1.75H9.875a.875.875 0 1 1 0-1.75h12.25z" /><path d="M11.112 16l5.507 5.506a.875.875 0 1 1-1.238 1.238l-6.125-6.125a.875.875 0 0 1 0-1.238l6.125-6.125a.875.875 0 1 1 1.238 1.238L11.112 16z" /></g></g></svg>;
});